import classNames from 'classnames';
import * as React from 'react';
import { Link } from '../../../../routes';
import css from './Breadcrumbs.module.scss';

interface Props {
  className?: string;
  breadcrumbs: Array<{
    url: string;
    text: string;
  }>;
}

const Breadcrumbs = ({ className, breadcrumbs }: Props) => {
  const classes = classNames(css.Breadcrumbs, className);

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <ul className={css.Breadcrumbs__List}>
        {breadcrumbs.map((breadcrumb, i) => (
          // TODO: SP時2行までで truncate する
          <li key={i} className={css.Breadcrumbs__Item}>
            <Link href={breadcrumb.url} prefetch={false}>
              <a className={css.Breadcrumbs__Link}>{breadcrumb.text}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
